export const allDevicesPickUpStoreReset = () => {
	if ($('input[name=allItems10005]').val() == "true"){
    	$('#shipToAddressRadio').prop("checked",true).change();
    	$('input[name=pickupSelected]').val('false');
    	$('input[name=allItems10005]').val('false');
    };
};
